import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ExtractCloudComponent } from './extract-cloud/extract-cloud.component';
import { RouterModule, Routes } from "@angular/router";
import { CloudExtractLandingComponent } from "./cloud-extract-landing/cloud-extract-landing.component";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule,ReactiveFormsModule } from "@angular/forms";
import { SelectComponent } from './select/select.component';
import { SubmitComponent } from './submit/submit.component';
import { ExtractComponent } from './extract/extract.component';
import { ConfigPopupComponent } from './config-popup/config-popup.component';
import { ExtractBatchFromCloudComponent } from './extract-batch-from-cloud/extract-batch-from-cloud.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ParametersComponent } from './parameters/parameters.component';
import { ParamsPopupComponent } from './params-popup/params-popup.component';

const routes: Routes = [
  {
    path: "",
    component: ExtractCloudComponent,
    children: [
      { path: "", component: CloudExtractLandingComponent, pathMatch: "full" },
      {
        path: "", component: ExtractBatchFromCloudComponent,
        children: [
          { path: "select", component: SelectComponent },
          { path: "submit", component: SubmitComponent },
          { path: "extract", component: ExtractComponent },
          { path: "params", component: ParametersComponent }
        ]
      }
    ]
  }
];

@NgModule({
  declarations: [ExtractCloudComponent, CloudExtractLandingComponent, SelectComponent, SubmitComponent, ConfigPopupComponent, ExtractBatchFromCloudComponent, ExtractComponent, ParametersComponent, ParamsPopupComponent],
  imports: [
    CommonModule,
    FormsModule,ReactiveFormsModule,
    SharedModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CloudExtractModule { }
